import React, { Component } from "react";
import { Paper, RaisedButton } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class EmailEvents extends Component {
  componentWillMount() {
    this.props.authFetchWorkorders("email/events", this.props.token.jwt);
  }

  render() {
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h3>Sendgrid Events</h3>
          </center>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn dataField="email" filter={filter} dataSort isKey>
              Email
            </TableHeaderColumn>
            <TableHeaderColumn dataField="event" dataSort filter={filter}>
              Event
            </TableHeaderColumn>
            <TableHeaderColumn dataField="timestamp" dataSort filter={filter}>
              Time
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/EmailEvents.js